<template>
  <div>
    <van-nav-bar
      fixed
      :left-arrow="hasLeft"
      :safe-area-inset-top="true"
      @click-left="leftBut"
      class="header-box"
    >
      <template #title>
        <h5 class="van-bar-title">
          {{ pageTitle }}
        </h5>
      </template>
      <template #right>
        <slot name="right"></slot>
      </template>
    </van-nav-bar>
  </div>
</template>

<script>
import { NavBar } from "vant";
export default {
  name: "Header",
  components: {
    "van-nav-bar": NavBar,
  },
  props: {
    // 是否显示退回按钮
    hasLeft: {
      type: Boolean,
      default: true,
    },
    pageTitle: {
      // nav显示页面标题
      type: String,
      default: "",
    },
    goUrl:{
      // 指定返回的路径
      type: String,
      default: "",
    }
  },
  data() {
    return {};
  },
  methods: {
    // 左侧按钮(gubeit为协商的方法名)
    leftBut() {
      if (this.$route.query.out) {
        // 有out代表是APP进入
        if (this.$global.isAndroid_ios()) {
          window.android.gubeit();
        } else {
          window.webkit.messageHandlers.gubeit.postMessage("null"); //ios
        }
      } else {
        if(this.goUrl){
          this.$router.push(this.goUrl)
        }else{
          window.history.go(-1);
        }
        
      }
      // if(history.length > 1) {
      //   console.log("history>1",history.length)
      //   history.back();
      //   // location.reload(true)
      //   console.log("history>1",history.length)
      // } else {
      //   if (this.$global.isAndroid_ios()) {
      //     window.android.gubeit();
      //   } else {
      //     window.webkit.messageHandlers.gubeit.postMessage("null"); //ios
      //   }
      // }
    },
  },
};
</script>

<style scoped lang="scss">
.header-box {
  z-index: 999;
}
::v-deep .van-nav-bar__content {
  height: 44px;
}
::v-deep .van-hairline--bottom::after {
  border: none;
}
::v-deep .van-icon-ellipsis:before {
  font-size: 25px;
  color: #333;
}
::v-deep .van-icon-arrow-left:before {
  font-size: 20px;
  color: #333;
}
.van-bar-title {
  font-size: 18px;
  color: #333333;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  max-width: 50vw;
  line-height: 100%;
}
</style>
